import React, { useEffect, useState } from "react";
import "../css/style.css";
import axios from "axios";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import moment from "jalali-moment";

interface Coin {
  price: number;
  purchasePrice: number;
  coinName: string;
  salePurchase: number;
  registerDate: string;
}

function CoinPrices() {
  const tblRow = ["سکه/ارز", "قیمت خرید (تومان)", "قیمت فروش (تومان)"];
  const coinTypes = ["سکه امامی", "نیم سکه", "دلار"];
  const [coinData, setCoinData] = useState<Array<Coin>>([]);
  const [RegisterTime, setRegisterTime] = useState("");
  useEffect(() => {
    fetching();
  }, []);

  const fetching = async () => {
    const { status, data } = await axios.get(
      "https://charismaex.ir:200/api/Report/GetCoinPrices"
    );
    if (status === 200) {
      setCoinData(data);

      const d = moment(data[0].registerDate)
        .locale("fa")
        .format("dddd DD MMMM YYYY HH:mm");
      const newdate = [
        ...d.split(" ").splice(0, 4),
        " ساعت: ",
        ...d.split(" ").splice(4),
      ];
      setRegisterTime(newdate.join(""));
    }
  };

  return (
    <div className="container">
      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <TableContainer
          component={Paper}
          sx={{
            display: "flex",
            justifyContent: "center",
            width: "fit-content",
          }}
        >
          <Table sx={{ width: "65rem" }} aria-label="simple table">
            <TableHead>
              <TableRow sx={{ backgroundColor: "#F8E3E3" }}>
                <TableCell align="right">
                  <Typography variant="body1" color="initial">
                    تاریخ بروز رسانی: {RegisterTime}
                  </Typography>
                </TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
              </TableRow>
              <TableRow>
                {tblRow?.map(
                  (x, idx) => (
                    <TableCell className="ratesTh" key={idx} align="center">
                      {x}
                    </TableCell>
                  )
                  // <th className='th' key={idx}>{x}</th>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {coinData?.map((x, idx) => (
                <TableRow
                  key={idx}
                  className="ratesTr"
                  sx={{ "&:last-child , &:last-child": { border: 0 } }}
                >
                  <TableCell className="ratesTd" align="center">
                    {x.coinName ? x.coinName : "-"}
                  </TableCell>
                  <TableCell className="ratesTd" align="center">
                    {x.purchasePrice ? x.purchasePrice.toLocaleString() : "-"}
                  </TableCell>
                  <TableCell className="ratesTd" align="center">
                    {x.salePurchase ? x.salePurchase.toLocaleString() : "-"}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
}

export default CoinPrices;
